import { confirmAlert } from 'react-confirm-alert';

import { DeleteFacesConfirmation } from './DeleteFacesConfirmation';

interface ConfirmDeleteFacesProps {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
}
export function confirmDeleteFaces({
  onConfirm,
  onReject,
}: ConfirmDeleteFacesProps): void {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <DeleteFacesConfirmation
          onConfirm={() => {
            onConfirm();
            onClose();
          }}
          onReject={() => {
            onReject?.();
            onClose();
          }}
        />
      );
    },
  });
}
